module.exports = __webpack_public_path__ + "static/img/insta.34ada16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/insta.png
// module id = ZLNX
// module chunks = 94